<template>
    <v-container fluid grid-list-md>
        <reports></reports>
    </v-container>
</template>

<script>
import Reports from '../components/Reports/List.vue';

export default {
  components: {
    Reports
  }
};
</script>
